import { useActiveClassroom } from '../context/ActiveClassroomProvider.js';
import styles from './LiveBackButton.module.css';

/**
 * Top-left back chevron rendered while a classroom is live (active
 * morning-meeting view). Pressing it exits the active classroom and
 * returns to the hub's classroom list — replaces the old
 * "Back to classrooms" affordance.
 *
 * Hidden when no classroom is active or while the search overlay
 * is open (search has its own close affordance).
 */
export function LiveBackButton() {
  const { active, subPage, leave } = useActiveClassroom();
  if (!active || subPage === 'search') return null;
  return (
    <button
      type="button"
      className={styles.button}
      onClick={leave}
      aria-label="Back to classrooms"
      data-testid="live-back"
    >
      <svg
        viewBox="0 0 24 24"
        width="18"
        height="18"
        aria-hidden="true"
        focusable="false"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M15 18l-6-6 6-6" />
      </svg>
    </button>
  );
}
